import React from 'react';
import {FormattedMessage} from "react-intl";

import {black400, black500} from "assets/jss/main";

function NoNotifications(props) {
    return (
        <div style={{
            paddingTop: '48px',
            paddingBottom: '48px',
            textAlign: 'center',
            fontSize: '14px',

        }}>
            <div style={{
                transform: 'rotate(30deg)',
                fontSize: '48px',
                marginBottom: '40px'
            }}>
                🔔
            </div>
            <div>
                <div style={{
                    fontWeight: 600,
                    color: black500,
                    marginBottom: '16px'
                }}>
                    <FormattedMessage id='sidebar.profil.notification.menu.empty' />
                </div>
                <div style={{ color: black400 }}>
                    <FormattedMessage id='sidebar.profil.notification.menu.empty.sub' />
                </div>
            </div>
        </div>
    );
}

export default NoNotifications;
